import { render } from "./ExpectedEarnings.vue?vue&type=template&id=63b54592&ts=true"
import script from "./ExpectedEarnings.vue?vue&type=script&lang=ts"
export * from "./ExpectedEarnings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__